var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              !_setup.props.size
                ? _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            icon: "",
                            loading: _setup.downloading,
                            disabled: _setup.downloading,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _setup.printTicket.apply(null, arguments)
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [_c("v-icon", [_vm._v("mdi-printer")])],
                    1
                  )
                : _setup.props.size === "small"
                ? _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            small: "",
                            icon: "",
                            loading: _setup.downloading,
                            disabled: _setup.downloading,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _setup.printTicket.apply(null, arguments)
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v("mdi-printer"),
                      ]),
                    ],
                    1
                  )
                : _setup.props.size === "x-small"
                ? _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            "x-small": "",
                            icon: "",
                            loading: _setup.downloading,
                            disabled: _setup.downloading,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _setup.printTicket.apply(null, arguments)
                            },
                          },
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v("mdi-printer"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
        },
      ]),
    },
    [_c("span", [_vm._v("Print")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }